import './src/main.css'
import PercentPond from './src/main.vue'

export default function (Vue) {
  Vue.component(PercentPond.name, PercentPond)
}
